var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.9 3C2.40294 3 2 3.40294 2 3.9V17.4C2 17.8971 2.40294 18.3 2.9 18.3H9.2C9.67739 18.3 10.1352 18.4896 10.4728 18.8272C10.8104 19.1648 11 19.6226 11 20.1C11 20.5971 11.4029 21 11.9 21C12.3971 21 12.8 20.5971 12.8 20.1C12.8 19.6226 12.9896 19.1648 13.3272 18.8272C13.6648 18.4896 14.1226 18.3 14.6 18.3H20.9C21.3971 18.3 21.8 17.8971 21.8 17.4V3.9C21.8 3.40294 21.3971 3 20.9 3H15.5C14.3065 3 13.1619 3.47411 12.318 4.31802C12.1666 4.46947 12.027 4.63061 11.9 4.79997C11.773 4.63061 11.6334 4.46947 11.482 4.31802C10.6381 3.47411 9.49347 3 8.3 3H2.9ZM12.8 16.9823C13.3426 16.669 13.9626 16.5 14.6 16.5H20V4.8H15.5C14.7839 4.8 14.0972 5.08446 13.5908 5.59081C13.0845 6.09716 12.8 6.78392 12.8 7.5V16.9823ZM11 16.9823V7.5C11 6.78392 10.7155 6.09716 10.2092 5.59081C9.70284 5.08446 9.01608 4.8 8.3 4.8H3.8V16.5H9.2C9.83741 16.5 10.4574 16.669 11 16.9823Z",
    fill: "#3A4555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpen);
export default __webpack_public_path__ + "static/media/book-open.378af2380bfb7266ae38a534e96992d3.svg";
export { ForwardRef as ReactComponent };